import script from "./VouchersShopPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersShopPage.vue?vue&type=script&setup=true&lang=ts"

import "./VouchersShopPage.vue?vue&type=style&index=0&id=33ccba84&scoped=true&lang=css"
import "./VouchersShopPage.vue?vue&type=style&index=1&id=33ccba84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ccba84"]])

export default __exports__